import { type ComponentRef, forwardRef } from "react";
import styled from "styled-components";

import {
	PlateElement,
	type PlateElementProps,
} from "@platejs/core/react";

export const BlockquoteElement = forwardRef<
	ComponentRef<typeof PlateElement>,
	PlateElementProps
>(({ children, ...props }, ref) => (
	<PlateElement ref={ref} {...props}>
		<Blockquote>
			{children}
		</Blockquote>
	</PlateElement>
));

const Blockquote = styled.blockquote`
  background: #F9F9F9;
  border-left: 10px solid #CCC;
	font-style: italic;
  margin: 1.5em 10px;
  padding: 0.5em 10px;

	&:before {
		color: #CCC;
		content: open-quote;
		font-size: 4em;
		line-height: 0.1em;
		margin-right: 0.25em;
		vertical-align: -0.4em;
	}

	p {
		display: inline;
	}
`;

BlockquoteElement.displayName = "BlockquoteElement";
